<template>
  <div class="home">
    <app-header style="margin-bottom:3%;"></app-header>
    <app-rtap-header style="margin-bottom:2%;"></app-rtap-header>
    <app-how-it-works></app-how-it-works>
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/general/Header.vue";
import RTapHeader from "@/components/general/RTapHeader.vue";
import HowItWorks from "@/components/rtap/HowItWorks.vue";
import Footer from "@/components/general/Footer.vue";

export default {
name: "home",
components: {
  'app-header': Header,
  'app-rtap-header': RTapHeader,
  'app-how-it-works': HowItWorks,
  'app-footer' : Footer,
  }
}   

</script>
